import { Stack, Typography } from "@mui/material";
import { LocationOn, ContentCut, X } from "@mui/icons-material";

export const renderDetailedItem = (fields, event, events) => {
  return (
    <>
      {fields.map(() => {
        return (
          <Stack>
            <Typography
              key={`loc-${event.event_id}`}
              className="d-flex align-items-center"
              color="textSecondary"
              variant="caption"
              noWrap
            >
              <LocationOn />
              <Typography sx={{ paddingLeft: "8px", fontSize: 12 }}>
                {event.location?.location_name || ""}
              </Typography>
            </Typography>
            <Typography
              key={`services-${event.event_id}`}
              className="d-flex align-items-center"
              color="textPrimary"
              variant="caption"
              noWrap
            >
              <ContentCut className="p-1" />
              <Stack>
                {event.uniqueServices.map((service, i) => (
                  <Typography
                    key={`${service.service_id}${i}`}
                    sx={{
                      paddingLeft: "8px",
                      fontWeight: "bold",
                      fontSize: 12,
                    }}
                  >
                    {service.title}
                  </Typography>
                ))}
              </Stack>
            </Typography>
          </Stack>
        );
      })}
    </>
  );
};
